<template>
  <div id="gjxBox">
    <div class="banner">
        <img src="../../assets/img/5.0/aigjxbg.png" alt="">
    </div>
    <div class="bread">
        当前位置：<span @click="goAI">AI教研</span><span>/</span><span style="color:#1E60EB;">AI教学工具箱</span>
    </div>
    <div class="content" v-for="(item,index) in aiLists" :key="index" :id="'ai'+ item.id">
        <div class="toolbox">
            <div class="top">
                <h3>{{item.title}}</h3>
            </div>
            <div class="Lists">
                <div class="card" v-for="(list,num) in item.arr" :key="list.name" @mouseleave="indexHover = null"  @mouseenter="handleMouseEnter(index+num)" @click="goLink(list)">
                    <div class="title">
                        <p>{{list.name}}</p>
                    </div>
                    <div class="desc">
                        {{list.desc}}
                    </div>
                    <div class="next">
                        <img src="../../assets/img/5.0/next.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="floatLeft">
        <div class="title" v-for="(item,index) in aiLists" :key="index" @click.prevent="smoothScrollTo('#ai'+item.id,item.id)" :class="{chosedTitle:chosed == item.id}">{{item.title}}</div>
        <div class="title" @click="goTop"><img src="../../assets/img/5.0/goTop.png" alt=""> 返回顶部</div>
    </div>
    <div class="tips">*内容由AI大模型生成，请仔细甄别</div>
  </div>
</template>

<script>
export default {
  data() {
    return{
        chosed:1,
        aiLists:[
            {title:'万师严选神器',
                id:1,
                arr:[
                    {
                        name: "DeepSeek",
                        // pic: require("../../assets/img/1.png"), 
                        desc: "国产最强 教育腾飞",
                        link: "https://www.deepseek.com/",
                    },
                    {
                        name: "豆包",
                        desc: "字节实力打造",
                        link: "https://www.doubao.com/",
                    },
                    {
                        name: "Kimi",
                        desc: "智能助力教育",
                        link: "https://kimi.moonshot.cn/",
                    },
                    {
                        name: "讯飞星火",
                        desc: "讯飞赋能AI教育",
                        link: "https://xinghuo.xfyun.cn/",
                    },
                    {
                        name: "谱智清言",
                        desc: "清华打造 高效教学",
                        link: "https://chatglm.cn/",
                    },
                    {
                        name: "腾讯元宝",
                        desc: "腾讯助力 教效翻倍",
                        link: "https://yuanbao.tencent.com/",
                    },
                    {
                        name: "通义千问",
                        desc: "阿里出品 教学突破",
                        link: "https://qianwen.aliyun.com/",
                    },
                    // {
                    //     name: "文心一言",
                    //     desc: "百度全新一代知识增强大语言模型",
                    //     link: "https://yiyan.baidu.com/",
                    // },
                ]
            },
            {title:'AI教学设计',
            id:2,
                arr:[
                    {
                        name: "笔灵AI",
                        desc: "多模版 撰写神速",
                        link: "https://bimoxiezuo.com/home",
                    },
                    {
                        name: "匠邦AI",
                        desc: "精研教案 拿来即用",
                        link: "https://ai.jbangai.com/",
                    },
                    {
                        name: "万彩AI",
                        desc: "一键生成 资源丰富",
                        link: "https://ai.kezhan365.com/",
                    },
                ]
            },
            {title:'AI出题',
            id:3,
                arr:[
                    {
                        name: "组卷 AI",
                        desc: "智能组卷 轻松测验",
                        link: "https://bimoxiezuo.com/home",
                    },
                    {
                        name: "豆包AI出题",
                        desc: "多题型 免费下载",
                        link: "https://www.doubao.com/chat/",
                    },
                    {
                        name: "Deepseek",
                        desc: "10秒生成全科试卷",
                        link: "https://www.deepseek.com/",
                    },
                ]
            },
            {title:'AI报告总结',
            id:4,
                arr:[
                    {
                        name: "万彩AI",
                        desc: "一键写总结 更省心",
                        link: "https://ai.kezhan365.com/copywriting/40018",
                    },
                    {
                        name: "言笔AI",
                        desc: "高效生成报告",
                        link: "https://www.yanbiai.com/tools/course-report",
                    },
                ]
            },
            {title:'AI批改作业',
            id:5,
                arr:[
                    {
                        name: "豆包AI改作业",
                        desc: "拍照批改 效质双高",
                        link: "https://www.doubao.com/chat/",
                    },
                    {
                        name: "文心一言",
                        desc: "智能批改 减负提效",
                        link: "https://yiyan.baidu.com/",
                    },
                    {
                        name: "Regrammar",
                        desc: "英语作文语法快速修改",
                        link: "https://www.regrammar.com/",
                    },
                ]
            },
            {title:'AI思维导图',
            id:6,
                arr:[
                    {
                        name: "ProcessOn",
                        desc: "AI绘制 梳理思路",
                        link: "https://www.processon.com/",
                    },
                    {
                        name: "亿图脑图",
                        desc: "专业导图 教学清晰",
                        link: "https://www.edrawsoft.cn/mindmaster/",
                    },
                    {
                        name: "GitMind 思乎",
                        desc: "便捷 AI 导图 ",
                        link: "https://gitmind.cn/",
                    },
                    {
                        name: "Boardmix 白板",
                        desc: "白板+AI 创意多",
                        link: "https://boardmix.cn/ai-whiteboard/",
                    },
                    // {
                    //     name: "妙办画板",
                    //     desc: "2000+教育模版",
                    //     link: "about:blank",
                    // },
                ]
            },
            {title:'AI外语学习',
            id:7,
                arr:[
                    {
                        name: "彩云小译",
                        desc: "多格式文档翻译",
                        link: "https://fanyi.caiyunapp.com/",
                    },
                    {
                        name: "多样翻译 外语无忧",
                        desc: "多格式文档翻译",
                        link: "https://sight.youdao.com/",
                    },
                ]
            },
            {title:'AI搜索资料',
            id:8,
                arr:[
                    // {
                    //     name: "天工 AI 搜索",
                    //     desc: "智能聚合 精准速查",
                    //     link: "about:blank",
                    // },
                    {
                        name: "纳米AI搜索",
                        desc: "360出品 搜索佳",
                        link: "https://ai.360.com/",
                    },
                    {
                        name: "秘塔 AI 搜索",
                        desc: "无广告搜索",
                        link: "无广告搜索",
                    },
                ]
            },
            {title:'AI做图片',
            id:9,
                arr:[
                    {
                        name: "通义万相",
                        desc: "阿里产品 AI生图",
                        link: "https://tongyi.aliyun.com/wanxiang/",
                    },
                    {
                        name: "文心一格",
                        desc: "文字生成精美图片",
                        link: "https://yige.baidu.com/",
                    },
                    {
                        name: "搜狐简单 AI",
                        desc: "定制多种教学图片",
                        link: "https://ai.sohu.com/pc/home",
                    },
                    {
                        name: "无限画",
                        desc: "3亿人都在用",
                        link: "https://588ku.com/ai/wuxianhua/Home",
                    },
                    {
                        name: "佐糖",
                        desc: "AI图像创作神器",
                        link: "https://picwish.cn/",
                    },
                ]
            },
            {title:'AI做视频',
            id:10,
                arr:[
                    {
                        name: "即梦 AI",
                        desc: "抖音出品 功能强大",
                        link: "https://jimeng.jianying.com/ai-tool/home",
                    },
                    {
                        name: "可灵 AI",
                        desc: "动画视频效果佳",
                        link: "https://app.klingai.com/cn/",
                    },
                    {
                        name: "海螺 AI",
                        desc: "文本生成视频",
                        link: "https://hailuoai.com/video",
                    },
                    {
                        name: "通义万相",
                        desc: "AI免费制作视频",
                        link: "https://tongyi.aliyun.com/wanxiang/",
                    },
                ]
            },
            {title:'AI做PPT',
            id:11,
                arr:[
                    {
                        name: "AI PPT",
                        desc: "每日两次免费生成",
                        link: "https://www.aippt.cn/",
                    },
                    {
                        name: "Kimi PPT 助手",
                        desc: "不限次数生成",
                        link: "https://kimi.moonshot.cn/?from=aito",
                    },
                    {
                        name: "讯飞智文",
                        desc: "一句话创建PPT",
                        link: "https://zhiwen.xfyun.cn/",
                    },
                    {
                        name: "WPS AI",
                        desc: "生成 PPT 神速",
                        link: "https://ai.wps.cn/",
                    },
                    {
                        name: "iSlide PPT",
                        desc: "一个主题即可生成",
                        link: "https://www.islide.cc/?mtm_campaign=aigjg",
                    },
                ]
            },
            {title:'AI分析成绩',
            id:12,
                arr:[
                    {
                        name: "Kimi成绩分析助手",
                        desc: "提分策略精准",
                        link: "https://kimi.moonshot.cn/",
                    },
                    {
                        name: "Deepseek",
                        desc: "智能剖析成绩",
                        link: "https://chat.deepseek.com/",
                    },
                ]
            },
            {title:'AI家校沟通',
            id:13,
                arr:[
                    {
                        name: "匠邦AI",
                        desc: "提供多种沟通话术",
                        link: "https://ai.jbangai.com/",
                    },
                ]
            },
            {title:'AI点名',
            id:14,
                arr:[
                    {
                        name: "Deepseek",
                        desc: "一键生成随机点名",
                        link: "https://chat.deepseek.com/",
                    },
                    {
                        name: "匠邦AI",
                        desc: "教师全能好帮手",
                        link: "https://ai.jbangai.com/",
                    },
                ]
            },
            {title:'AI微课',
            id:15,
                arr:[
                    {
                        name: "KIMI 文案助手",
                        desc: "微课文案轻松设计",
                        link: "https://kimi.moonshot.cn/?from=aito",
                    },
                    {
                        name: "腾讯有言",
                        desc: "一键生成数字人讲解",
                        link: "https://www.youyan3d.com/",
                    },
                    {
                        name: "即梦AI",
                        desc: "图生视频 人物说话",
                        link: "https://jimeng.jianying.com/ai-tool/home",
                    },
                ]
            },
            {title:'AI教学论文',
            id:16,
                arr:[
                    {
                        name: "KIMI",
                        desc: "一键搭建论文框架",
                        link: "https://kimi.moonshot.cn/?from=aito",
                    },
                    {
                        name: "Deepseek",
                        desc: "快速检索最新文献",
                        link: "https://www.deepseek.com/",
                    },
                ]
            },
            
        ],
        indexHover:null,
    }
    
  },
  created(){
    console.log(123)
  },
  methods: {
    handleMouseEnter(index){
        this.indexHover = index
    },
    goLink(e){
        window.open(e.link, '_blank');
    },
    goAI(){
        // window.location.href = "https://jyptwebtest.idianjiao.com/pc/AIjiaoyan"
        this.$router.push({
           path: "/AIjiaoyan",
        })
    },
     smoothScrollTo(selector,id) {
        console.log(selector)
        const select = document.querySelector(selector);
        console.log(select)
        let scrollHeight = select.offsetTop - 80;
        console.log(scrollHeight);
        this.chosed = id
        window.scrollTo({
            top: scrollHeight,
            behavior: "smooth",
        });
    },
    goTop(){
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    },
  },
};
</script>

<style scoped lang="less">
#gjxBox{
    background-color: #f0f2f5;
    overflow: hidden;
    // height: 100vh;
    .banner{
        margin: 0 auto;
        width: 1200px;
        height: 320px;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .bread{
        display: flex;
        align-items: center;
        margin: 0 auto;
        width: 1200px;
        height: 50px;
        font-size: 14px;
        color: #626366;
        span{
            padding: 0  6px;
            font-size: 14px;
            color: #626366;
            cursor: pointer;
        }
        span:hover{
            color: #1E60EB;
        }
    }
    .content{
        margin: 0 auto;
        margin-bottom: 20px;
        width: 1200px;
        // height: 80%;
        background: #FFF;
        border-radius: 10px;
        .toolbox{
            .top{
                overflow: hidden;
                h3{
                    margin: 30px;
                    padding-left: 5px;
                    font-size: 16px;
                    color: #333333;
                    font-weight: bold;
                    border-left: 3px solid #1E60EB;
                }
            }
            .Lists{
                display: flex;
                flex-wrap: wrap;
                margin-left: 40px;
                .card{
                    position: relative;
                    display: flex;
                    flex-direction: column;
                    margin-right: 40px;
                    margin-bottom: 30px;
                    width: 226px;
                    height: 116px;
                    background: #F6F6F6;
                    border-radius: 10px;
                    cursor: pointer;
                    background-image: url('../../assets/img/5.0/aigjxbg2.png');
                    background-repeat: no-repeat;
                    background-size: 100%;
                    .title{
                        display: flex;
                        align-items: center;
                        margin-left: 20px;
                        font-size: 16px;
                        color: #333333;
                        font-weight: bold;
                        p{
                            margin: 0;
                            margin-top: 15px;
                            margin-bottom: 5px;
                        }
                    }
                    .desc{
                        margin-top: 5px;
                        margin-left: 20px;
                        font-size: 14px;
                        color: #1E60EB;
                        width: 150px;
                    }
                    .next{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        position: absolute;
                        right: 10px;
                        bottom: 10px;
                        width: 32px;
                        height: 32px;
                        background: #FFFFFF;
                        border-radius: 50%;
                        img{
                            width: 50%;
                        }
                    }
                    .url{
                        position: absolute;
                        right: -100px;
                        top: 30px;
                        padding: 0 10px;
                        line-height: 40px;
                        height: 40px;
                        background: #FFFFFF;
                        border-radius: 10px;
                        z-index: 2;
                    }
                }
                .card:hover{
                    position: relative;
                    top: -4px;
                    box-shadow: 0px 6px 12px 0px rgba(0,0,0,0.2);
                    .title{
                        color: #1E60EB;
                    }
                }
            }
        }
    }
    .floatLeft{
        display: inline-block;
        position: fixed;
        left: 20px;
        top: 10%;
        z-index: 100;
        width: 120px;
        background: #FFFFFF;
        border-radius: 4px;
        .title{
            text-align: center;
            line-height: 44px;
            width: 120px;
            height: 44px;
            color: #333;
            cursor: pointer;
            user-select: none;
            border-radius: 4px;
            font-size: 14px;
            img{
                width: 12px;
            }
        }
        .title:hover{
            background: #1E60EB;
            color: #FFF;
        }
        .chosedTitle{
            background: #1E60EB;
            color: #FFF;
        }
    }
    .tips{
        margin-top: 30px;
        text-align: center;
        font-size: 14px;
        color: #999999;
    }
}
</style>